import { forwardRef } from 'react';
import Switch from '@mui/material/Switch';
import { ICSwitch } from 'types/atoms';

const CSwitch = forwardRef<HTMLSpanElement, ICSwitch>((props, ref) => {
  return (
    <Switch
      {...props}
      inputRef={ref}
      classes={{
        root: 'h-[26px] w-[42px] p-0',
        switchBase: 'm-[2px] p-0 duration-300',
        thumb: 'box-border h-[22px] w-[22px] border border-neutral-100  bg-neutral-0',
        track:
          'rounded-[13px] bg-neutral-200 opacity-100 duration-500 [.Mui-checked+.MuiSwitch-track&]:bg-secondary-800 [.Mui-checked+.MuiSwitch-track&]:opacity-100 [.Mui-checked.Mui-disabled+.MuiSwitch-track&]:bg-secondary-800 [.Mui-disabled+.MuiSwitch-track&]:bg-neutral-100  [.Mui-disabled+.MuiSwitch-track&]:opacity-50',
        checked: '[&.Mui-checked]:translate-x-4 [&.Mui-checked]:text-secondary',
      }}
    />
  );
});

export default CSwitch;
